import { useEffect, useState } from "react";
import { Building2, Server, Hash, Users, Signal, PhoneCall } from "lucide-react";
import { api } from "../../lib/api";
import { LogsTab } from "./LogsTab";

const CARDS = [
  { key: "sites", label: "Sites", icon: Building2, color: "text-cyan-400", tab: "sites" },
  { key: "servers", label: "SIP Servers", icon: Server, color: "text-emerald-400", tab: "servers" },
  { key: "extensions", label: "Extensions", icon: Hash, color: "text-amber-400", tab: "extensions" },
  { key: "users", label: "Tenant Accounts", icon: Users, color: "text-slate-300", tab: "users" },
  { key: "online_users", label: "Online Now", icon: Signal, color: "text-emerald-400", tab: "users" },
  { key: "calls_today", label: "Calls Today", icon: PhoneCall, color: "text-cyan-400", tab: "logs" },
];

export function OverviewTab({ goTo }) {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    const load = () => api.get("/admin/stats").then((res) => setStats(res.data)).catch(() => {});
    load();
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="space-y-6" data-testid="overview-tab">
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4">
        {CARDS.map((c) => (
          <button key={c.key} data-testid={`stat-card-${c.key}`} onClick={() => goTo(c.tab)}
            className="ops-card p-4 text-left hover:border-[#2A364F] transition-colors">
            <c.icon className={`w-5 h-5 mb-3 ${c.color}`} />
            <div className="text-2xl font-bold font-mono text-slate-100" data-testid={`stat-value-${c.key}`}>
              {stats ? stats[c.key] : "—"}
            </div>
            <div className="ops-caption mt-1">{c.label}</div>
          </button>
        ))}
      </div>
      <div>
        <h3 className="text-lg font-semibold text-slate-100 mb-3">Recent Call Activity</h3>
        <LogsTab compact />
      </div>
    </div>
  );
}
